import axios from "axios";
import {
  API_BASE_URL,
  AXIOS_HEADERS_FILE,
} from "../../configs/variable.config";
import { useState } from "react";
import { Tooltip } from "@mui/material";
import { INTERNAL_PATHS } from "../../configs/routes.config";

const FileInput = (props) => {
  const [fileName, setFileName] = useState("");

  const OnChangeHandler = async (event) => {
    let imageDataUrl = await readFile(event.target.files[0]);
    setFileName(event.target.files[0].name);
    fetch(imageDataUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], event.target.files[0].name, {
          type: `${event.target.files[0].type}`,
        });
        console.log(file);
        const formData = new FormData();
        formData.append("image", file);
        formData.append("type", props.type);
        const arrey = API_BASE_URL.split("/");
        const fileUrl = `https://${arrey[2]}/api/v1/admin/files`;
        //${API_BASE_URL}${INTERNAL_PATHS.FILES}
        axios.post(`${fileUrl}`, formData).then((res) => {
          if (props.HasManyInputData) {
            props.HasManyInputData(
              props.index,
              props.HasManyKey,
              res.data.data.id
            );
          } else {
            let object = props.inputData;
            object[props.keyValue] = res.data.data.id;
            props.setInputData(object);
          }
        });
      });
  };

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }

  return (
    <>
      <div>
        <Tooltip
          title={props.item.help === undefined ? "" : props.item.help.body}
          placement="left-start"
          arrow
        >
          <label className="text-[14px] dark:text-[#D1D4C9] text-edit_input_label col-span-full sm:col-auto mb-1 mt-5 sm:mb-0 sm:mt-0">
            {props.item.label}
          </label>
        </Tooltip>
      </div>
      <div className="col-span-full sm:col-auto">
        <div className="flex items-center gap-2 ">
          <div className="relative cursor-pointer">
            {fileName === "" ? (
              <img
                src={
                  "https://cdn.icon-icons.com/icons2/602/PNG/512/Add_File_icon-icons.com_55973.png"
                }
                className="w-full max-w-[150px] aspect-square rounded-md border-dashed border-2 border-[#5ba9aa] pr-2 pb-2 bg-white dark:bg-[#ffffffdd]"
                alt=""
              />
            ) : (
              <span className="text-[14px] font-bold w-full rounded-md border-dashed border-2 border-[#5ba9aa] line-clamp-5 cursor-pointer p-1">
                {fileName}
              </span>
            )}
            <input
              className="opacity-0 absolute top-0 right-0 w-full h-full cursor-pointer"
              disabled={props.disabled}
              onChange={OnChangeHandler}
              index={props.index}
              accept={props.accept || "*"}
              type="file"
            />
          </div>
        </div>
        <div className="mt-2 text-[.8rem] text-edit_input_validation">
          {props.children}
        </div>
      </div>
    </>
  );
};

export default FileInput;
